export default __webpack_public_path__ + "static/media/transfert.746509ea.png";